/**
 * Common modal route definitions.
 */
export const routes = {
  feedback: '/common/feedback',
  featureRequest: '/common/featureRequest',
  success: '/common/success',
}
